import { create } from "zustand";
import { planApi } from "../services/plan-api";
import type { PlanState } from "../types";

export const usePlanStore = create<PlanState>((set) => ({
	planDetails: null,
	isLoading: false,
	error: null,

	getPlan: async (workspaceId: string) => {
		set({ isLoading: true, error: null });
		const result = await planApi.getPlan(workspaceId);

		if (result.success && result.data) {
			set({
				planDetails: result.data,
				isLoading: false,
			});
			return result.data;
		}

		set({
			isLoading: false,
			error: result.error || "Failed to fetch plan details",
		});
		return null;
	},

	clearPlan: () => {
		set({ planDetails: null, error: null });
	},
}));